<template>
    <auth-container>
        <h1 class="mb-12 text-center text-xl font-semibold">Passwort ändern</h1>
        <input-text
            class="mb-5 w-96"
            :name="'password'"
            :id="'password'"
            v-model="state.user.password"
            :label="'Passwort'"
            :type="'password'"
            :labelClass="'bg-white'"
        />
        <input-text
            class="mb-5 w-96"
            :name="'password_confirmation'"
            :id="'password_confirmation'"
            v-model="state.user.password_confirmation"
            :label="'Passwort wiederholen'"
            :labelClass="'bg-white'"
            :type="'password'"
            @enter="CHANGE_PASSWORD(state.user)"
        />

        <custom-button
            @click="CHANGE_PASSWORD(state.user)"
            class="w-96 h-11"
            :text="'Passwort ändern'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'password-change-button'"
        />
        <!-- <router-link
            tag="h4"
            :to="{ name: 'PasswordReset' }"
            class="absolute bottom-5 cursor-pointer text-grey transition-colors hover:text-grey-dark"
        >
            Passwort vergessen
        </router-link> -->
    </auth-container>
</template>

<script>
import { defineComponent, reactive } from "vue";
import CustomButton from "../../components/input/CustomButton.vue";
import InputText from "../../components/input/InputText.vue";
import { AUTH_TYPES, HELPER_TYPES, STORE_TYPES } from "../../store/types";

import { useStore } from "vuex";
import AuthContainer from "./helpers/AuthContainer.vue";
import { useRouter, useRoute } from "vue-router";
import { getData } from "../../common/dataHelper";
export default defineComponent({
    name: "PasswordChange",
    components: { InputText, CustomButton, AuthContainer },
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            user: {
                password: "",
                password_confirmation: "",
            },
        });
        /**
         * functions
         */
        async function CHANGE_PASSWORD(user) {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "password-change-button"
            );
            user.token = route.params.token;
            const result = await store.dispatch(
                `${STORE_TYPES.AUTH}/${AUTH_TYPES.CHANGE_PASSWORD}`,
                {
                    user,
                }
            );
            if (getData(result, "status") == 200) {
                router.push("/login");
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "password-change-button"
            );
        }

        return {
            state,
            CHANGE_PASSWORD,
        };
    },
});
</script>

<style></style>
